package one.healthium.db

import kotlin.Long
import kotlin.String

public data class ShoppingListDataEntity(
  public val id: String,
  public val listId: String,
  public val itemId: String,
  public val checked: Long,
)
